module.exports = __webpack_public_path__ + "static/media/search.ff789170.png";